'use client';
import { motion } from 'motion/react';
import React from 'react';

import { CMSLink, CMSLinkType } from '@/components/Link';
import { useLocale } from '@/contexts/LocaleContext';
import type { Media } from '@/payload-types';

import styles from './block.module.scss';

const childVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

type Props = {
  logo: Media;
  link: CMSLinkType;
  tracking?: {
    type: string;
    headline: string;
    cta: string;
  };
};

export default function LogoSingle({ link, logo, tracking }: Props) {
  const locale = useLocale();

  if (!logo) {
    return null;
  }

  const { url } = logo;

  return (
    <motion.div
      className={styles.logo}
      style={
        {
          '--mask-image': `url(${url})`,
          willChange: 'opacity',
        } as React.CSSProperties
      }
      variants={childVariants}
      transition={{ duration: 0.3 }}
    >
      {link.url || link.reference ? (
        <CMSLink
          locale={locale}
          ariaLabel={`Go to ${logo.alt} case`}
          {...link}
          tracking={{
            type: tracking?.type || 'Logo Wall - Global',
            headline: tracking?.headline || '',
            cta: tracking?.cta || (logo as Media)?.filename || '',
          }}
        >
          <div className={styles.image} />
        </CMSLink>
      ) : (
        <div className={styles.image} />
      )}
    </motion.div>
  );
}
